<ng-container
  ><button
    *ngIf="!show"
    _ngcontent-xfr-c47=""
    type="button"
    aria-label="append icon"
    class="v-icon notranslate v-icon--link mdi mdi-eye-off theme--light"
  ></button>

  <button
    *ngIf="show"
    type="button"
    aria-label="append icon"
    class="v-icon notranslate v-icon--link mdi mdi-eye theme--light"
  ></button>
</ng-container>
